import React from "react";
import Navigation from "../components/Navigation";
import Footer from "../components/Footer";
import Helmet from "react-helmet";
import SEO from "../components/SEO";
import config from "../meta/config";
import { Box } from '../components/Layout';
import colors from '../utils/colors.js';
import Hero from "../components/Hero";
import imageBig from "../assets/images/about-header-big.jpg";
import imageSmall from "../assets/images/about-header-small.jpg";

export default ({ data }) => {
    const {
        social_links,
        header,
        locations
    } = data.allBusinessJson.edges[0].node;
    const myTitle = 'Data Network Design, Cat6, Cat5, Fiber Optic Specialists | PCS';
    const myDesc = 'Preferred Cabling Systems has been installing data networks, cat5, cat6, and fiber optic cabling for over 25 years. PCS are BDA and DAS installation experts.'

    return <div>

        <SEO title={myTitle}
            description={myDesc}
        />
        <Navigation name={header.title} />
        <Hero imageBig={imageBig} imageSmall={imageSmall}>
            <Box color="white" p={[3, 3, 3]} align="left">
                <h1> Data Network & Fiber Optics Specialists </h1>
            </Box>
        </Hero>
        <Box color={colors.black}
            py={"2rem"}
            pl={["2em", "4em", "6em", "20em"]}
            pr={["2em", "4em", "6em", "20em"]}
            align="left">

            <h2 id="preferredcablingsystems--wearedata">Preferred Cabling Systems &#8211; We Are Data</h2>

            <p>Since Preferred Cabling Systems founding in 1990, the company has thrived under Mike Harrison’s leadership (President &amp; Founder) bursting into a nationwide IT Network brand that offers a broad range of Network Data Solutions which we ensure is maintained after installation.</p>

            <p>We make it easy for our clients by specializing in everything from design to engineering to implementation, we’ve got you covered. We want our clients to feel they have the help they need, which is why we are always here to help. We have client representatives on standby to help with design, data and communication needs.</p>

            <p>Our highly qualified engineering division will work alongside our clients and developers to outline the Low Voltage design on projects, making sure that all systems are code compliant with federal, state and local mandates.</p>

            <p>With over 25 years experience in every aspect of Broadband and network architecture, PCS is an easy choice for anything from public Wi-Fi projects to network fiber-optic lines to software upgrades and even integration. We even provide computers and end users with 24/7/365 support spanning to institutions across the nation; hospitality, medical as well as government operations.</p>

            <p>Though not limited to, here are some service offerings:</p>

            <ul>
                <li>Telecommunications</li>
                <li>Structured Cabling</li>
                <li>Bi-Directional Antenna (BDA)</li>
                <li>Distributed Antenna Systems (DAS)</li>
                <li>Fiber Optic Splicing</li>
                <li>Fiber Optics Installation</li>
                <li>Cat5e, Cat6, and Cat7</li>
                <li>Security Cameras and Entry Access</li>
                <li>Hotel Network Design</li>
                <li>Low Voltage Integrator</li>
                <li>Telephone Switches, HP Switches and Cisco Switches</li>
                <li>Fire Alarm installation</li>
                <li>Notifier Fire Alarms and</li>
                <li>Nurse Call</li>
            </ul>

            <p>PCS is also a leader in the provision of Fiber To The Office (FTTO), Fiber To The Room (FTTR) and Fiber To The Home(FTTH): . We provide services in the Building Automation Fields. This is generally explained in the context of Internet Of Things (ION).</p>

            <p>Contact us today so we can help you meet your Data and Network needs, and learn why <strong>We Are Data</strong>.</p>


        </Box>
    </div>;
};

export const query = graphql`
         query AboutQuery {
        allBusinessJson {
          edges {
            node {
            header {
              title
              headline
              subline
              }
            mission_statement
            locations {
              street
              city
              zip
              state
              }
            social_links {
              email
              linkedin
              facebook
              phone
              }
            }
          }
        }
      }
  `;



// WEBPACK FOOTER //
// ./src/pages/about.js